<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Kết quả thi</h2>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.score_status" filterable clearable placeholder="Trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="12"></el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-filter">
        <el-col :span="5">
          <el-select v-model="filter.school_id" filterable clearable placeholder="Chọn trường" class="input-select">
            <el-option
              v-for="item in lists.listSchool"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select">
            <el-option
              v-for="item in lists.listLevel"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.facult_id" filterable clearable placeholder="Chọn chuyên ngành" class="input-select">
            <el-option
              v-for="item in lists.listFacult"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.class_pro_id" filterable clearable placeholder="Chọn lớp" class="input-select">
            <el-option
              v-for="item in lists.listClassPro"
              :key="item.id"
              :label="item.code"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5"></el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới kết quả thi <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> kết quả thi
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
          width="40"
            type="index"
            label="#">
          </el-table-column>
          <el-table-column
            width="250"
            label="Họ và tên">
            <template slot-scope="scope">
              <div class="courses-info">
                <span>{{ scope.row.user_name }}</span>
                <span>{{ scope.row.user_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Lớp học">
            <template slot-scope="scope">
                <span>{{ scope.row.class_pro_code }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Môn học">
            <template slot-scope="scope">
              <span>{{ scope.row.course_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Kiểm tra">
            <template slot-scope="scope">
              <div class="courses-info">
                <strong>{{ scope.row.type_time_text }}</strong>
                <span>
                  <strong style="color: #4E92DF" v-if="scope.row.type_question == 1">{{ scope.row.type_question_text }}</strong>
                  <strong style="color: #e74c3c" v-if="scope.row.type_question == 2">{{ scope.row.type_question_text }}</strong>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            label="Điểm thi">
            <template slot-scope="scope">
                <span>{{ scope.row.score }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Kết quả">
            <template slot-scope="scope">
                <div v-if="scope.row.score_status == 2" class="item_active">
                  <span>{{ scope.row.score_status_txt }}</span>
                </div>
                <div v-if="scope.row.score_status == 1">
                  <span>{{ scope.row.score_status_txt }}</span>
                </div>
                <div v-if="scope.row.score_status == 0">
                  <span style="color: #f39c12">{{ scope.row.score_status_txt }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Ngày thi">
            <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Thi lại"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.can_test_again"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                :disabled="scope.row.status == 2"
                @change="changeTestAgain(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
<!--           <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column> -->
<!--           <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column
            width="180"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <!-- <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip> -->
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Kết quả thi'"
      :visible.sync="dialogVisible"
      top="20px"
      width="65%">
      <div>
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="test-list-result">
              <div class="item-question" v-for="(question, indexQuestion) in modelDetail.list_results" :key="indexQuestion">
                <div>
                  <strong>Câu {{ indexQuestion + 1 }} : </strong>
                  <strong v-html="question.text"></strong>
                </div>
                <div class="list-options test-options" v-if="modelDetail.type_question == 1">
                  <el-checkbox-group v-model="question.model_option">
                    <el-checkbox :label="option.id" v-for="(option,index) in question.options.data" :key="option.id">
                        <span>{{ returnTitle(index) }}</span>
                        <span v-if="option.is_answer" style="color: green">{{ option.text }}</span>
                        <span v-else>{{ option.text }}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="list-options test-options mb-2" v-if="modelDetail.type_question == 2">
                    <div class="file-upload-done pb-2 d-flex align-items-center" v-if="question.model_option.length">
                        <i class="far fa-file-alt"></i>
                        <span class="name">{{ question.model_option_name }}</span>
                        <i class="far fa-clock"></i>
                        <span class="time">{{ question.model_option_time }}</span>
                        <i class="far fa-eye"></i>
                        <a :href="question.model_option" target="_blank" class="view">Xem</a>
                    </div>
                    <div v-else>
                        <i>- Không có câu trả lời</i>
                    </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="test-info">
              <div>
                <strong>Tên đề thi:</strong>
                <span>{{ modelDetail.name }}</span>
              </div>
              <div>
                <strong>Khóa học:</strong>
                <span>{{ modelDetail.course_name }}</span>
              </div>
              <div>
                <strong>Học viên :</strong>
                <span>{{ modelDetail.user_name }}</span>
              </div>
              <div>
                <strong>Tổng số câu hỏi :</strong>
                <span>{{ modelDetail.total_question }}</span>
              </div>
              <div>
                <strong>Tổng số câu trả lời :</strong>
                <span>{{ modelDetail.total_answer }}</span>
              </div>
              <div>
                <strong>Tổng số câu trả lời đúng:</strong>
                <span>{{ modelDetail.total_success }}</span>
              </div>
              <div>
                <strong>Điểm số:</strong>
                <span>{{ modelDetail.score }} điểm</span>
              </div>
              <div>
                <strong>Đạt điều kiện vượt qua bài kiểm tra:</strong>
                <span>{{ modelDetail.score_status_txt }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="confirmSubmitSave(modelDetail)" size="small el-button el-button--warning el-button--small">Cập nhật</el-button>
          <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Lesssons',
  props: {
    user_id: Number
  },
  data () {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        score_status: '',
        user_id: '',
        test_kit_id: '',
        class_pro_id: '',
        level_id: '',
        facult_id: '',
        specialized_id: '',
        page: 1,
        limit: 50,
        sort: '',
        sorted: '',
        include: ''
      },
      dialogVisible: false,
      modelData: {
        name: '',
        email: '',
        user_id: 0,
        money: 5000000
      },
      modelDetail: '',
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        }
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 0, value: 'Chưa chấm điểm'},
          {key: 1, value: 'Không đạt'},
          {key: 2, value: 'Đạt'}
        ],
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: [],
        listTeacher: [],
        listClassPro: []
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.fetchDatabaseModel()
    this.fetchSchool()
  },
  methods: {
    returnTitle (index) {
      if (index === 0) return 'A.'
      if (index === 1) return 'B.'
      if (index === 2) return 'C.'
      if (index === 3) return 'D.'
    },
    ...mapActions(['setBreadcrumb']),
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'test-results-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Nút tạo Model
    createModelTestKit () {
      this.$router.push({name: 'test-kits-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('test-results', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id,
        'facult_id': this.filter.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchListTeacher () {
      let data = {
        'status': 1,
        'limit': -1,
        'user_type': 2,
        'school_id': this.filter.school_id
      }
      axios.get('users', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    fetchListClassPro () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id,
        'facult_id': this.filter.facult_id
      }
      axios.get('class-pros', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listClassPro = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      axios.get('test-results/' + model.id).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.modelDetail = response.data
            this.dialogVisible = true
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModel (model) {
      this.$router.push({name: 'test-results-update', params: {lesson_id: model.id, course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('test-results/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa kết quả thi bài học: ' + model.name + ' của ' + model.user_name + ' ?', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('test-results/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    confirmSubmitSave (model) {
        this.$confirm('Xác nhận sửa đáp án bài thi ?', 'Xác nhận', {
            confirmButtonText: 'Xác nhận',
            cancelButtonText: 'Hủy bỏ',
            type: 'warning'
        }).then(() => {
            this.submitSave(model);
        }).catch(() => {

        });
    },
    submitSave (model) {
        this.canSubmitSave = false;
        let data = {
            'list_results': this.modelDetail.list_results
        }
        axios.post('test-results/update-test-result/' + model.id, data).then(response => {
            this.canSubmitSave = true;
            switch (response.code) {
                case 200:
                    this.$notify({
                        title: 'Thành công',
                        message: 'Chỉnh sửa thành công',
                        type: 'success',
                        duration: '2000'
                    });
                    this.modelDetail = response.data
                    break;
                case 404:
                    break;
                default:
                    break;
            }
        })
    },
    changeTestAgain (model) {
      let dataUpdate = {
        'can_test_again': model.can_test_again
      }
      axios.post('test-results/update-test-again/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thi lại thành công',
              type: 'success',
              duration: '2000'
            })
            this.fetchDatabaseModel()
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    }
  },
  watch: {
    'filter.score_status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    },
    'filter.school_id': function () {
      this.filter.level_id = ''
      this.filter.facult_id = ''
      this.filter.specialized_id = ''
      this.filter.user_id = ''

      this.lists.listLevel = []
      this.lists.listFacult = []
      this.lists.listSpecialized = []
      this.lists.listTeacher = []

      if (this.filter.school_id) {
        this.fetchLevel()
        // this.fetchListTeacher()
        this.fetchListClassPro()
      }

      this.fetchDatabaseModel()
    },
    'filter.level_id': function () {
      this.filter.facult_id = ''
      this.filter.specialized_id = ''

      this.lists.listFacult = []
      this.lists.listSpecialized = []

      if (this.filter.level_id) {
        this.fetchFacult()
        this.fetchListClassPro()
      }

      this.fetchDatabaseModel()
    },
    'filter.facult_id': function () {
      this.filter.specialized_id = ''

      this.lists.listSpecialized = []

      if (this.filter.facult_id) {
        this.fetchSpecialized()
        this.fetchListClassPro()
      }

      this.fetchDatabaseModel()
    },
    'filter.specialized_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.class_pro_id': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
  .test-list-result {
    height: 500px;
    overflow-y: scroll;
  }

  /*// Copy từ con web*/
  .course-test {
    min-height: 100vh;
  }
  .test-content {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .name-company {
    max-width: 200px;
    text-align: left;
  }
  .name-company .name {
    text-transform: uppercase;
    font-weight: bold;
  }
  .name-company-mobile {
    width: 100%;
  }

  .name-company-mobile .name {
    text-transform: uppercase;
    font-weight: bold;
  }
  @media screen and (min-width: 768px) {
    .name-company .name {
      font-size: inherit;
    }
   .name-company .name-2 {
      min-height: 40px;
   }
  }
  .name-test-kit {
    text-align: right;
    max-width: 200px;
    margin-left: 15px;
  }
  @media screen and (min-width: 375px) {
    .name-test-kit {
      text-align: right;
      max-width: 250px;
    }
  }
  @media screen and (min-width: 768px) {
    .name-test-kit {
      max-width: 480px;
    }
  }
  .name-test-kit .name {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
  }
  @media screen and (min-width: 768px) {
    .name-test-kit .name {
      font-size: 15px;
    }
  }
  .name-test-kit .hold {
    text-transform: initial;
  }

  .item-question {
    margin-top: 15px;
  }
  .list-options .form-check {
    margin: 8px 0px;
  }
  .list-options .form-check input,
  .list-options .form-check label {
    cursor: pointer !important;
  }

  .test-info-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 15px;
  }
  .test-info {
    margin-top: 15px;
    padding: 15px;
    border-radius: 2px;
    background-color: #f2f2f2;
  }

  .test-options {

  }
  .test-options .el-radio-group {
    display: flex;
    flex-direction: column;
  }
  .test-options .el-radio {
    margin-left: 0px !important;
    line-height: 25px;
  }
  .test-options .el-radio:hover {
    color: #28A90C !important;
  }

  .test-kit-done {
    background-color: #f8f8f8;
    padding: 10px;
  }
</style>

<style>
  .test-list-result .el-radio {
    white-space: inherit;
    margin-bottom: 7px;
    line-height: 20px;
  }
  .el-input__icon {
      line-height: 25px !important;
  }

  .el-checkbox-group {
      display: flex;
      flex-direction: column;
  }
  .el-checkbox {
      margin-left: 0px !important;
      line-height: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/test-results-v2/Index.vue